import React from 'react';
import PackageList from '../Presentation/PackageList';
import SectionTitle from '../Presentation/SectionTitle';
import Loader from '../Presentation/Loader';
import {connect} from 'react-redux';
import {Button} from '../Presentation/Forms';
import Scroll from 'react-scroll';
let ScrollElement    = Scroll.Element;

class PackageWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: props.limit
        };

        this.showAll = this.showAll.bind(this);
    }

    showAll() {
        this.setState({limit: -1});
    }

    render() {
        const {title, className, packages, wrapperClassName, hideDescription, pending, id} = this.props;

        const moreBtn = <div className="text-center">
            <Button text="Виж всички" clickHandler={this.showAll} />
        </div>;
        let filteredPackages = packages.slice();
        const limit = this.state.limit || 3;
        const hasLimit = limit && limit !== -1;

        if (hasLimit) {
            filteredPackages = filteredPackages.slice(0, limit);
        }

        return <section className={wrapperClassName ? wrapperClassName : "packages-wrapper"}>
            <ScrollElement name={`category-${id}`}>
                <SectionTitle>{title}</SectionTitle>
                <Loader show={pending}/>
                <PackageList hideDescription={hideDescription} className={className + (pending ? " loading" : "") } packages={filteredPackages}/>
                { (hasLimit && packages && packages.length > limit) ? moreBtn : null}
            </ScrollElement>
        </section>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        pending: ownProps.pending
    }
};

export default connect(mapStateToProps)(PackageWrapper);


// WEBPACK FOOTER //
// ./src/components/Containers/PackageWrapper.js